import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider-approval',
  templateUrl: './provider-approval.component.html',
  styleUrls: ['./provider-approval.component.css']
})
export class ProviderApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/views/provider/provider-approval.component.ts